import type {
  CurrentMonthLoaderDayTile,
  CurrentMonthPastDayTile,
} from '../models';
import { PriceCalendarTileType } from '../models';

export function getCurrentMonthPastDayTile(
  date: Date
): CurrentMonthPastDayTile {
  return {
    type: PriceCalendarTileType.CurrentMonthPastDay,
    text: date.getDate().toString(),
    date,
  };
}

export function getCurrentMonthLoaderDayTile(
  date: Date
): CurrentMonthLoaderDayTile {
  return {
    type: PriceCalendarTileType.CurrentMonthLoaderDay,
    text: date.getDate().toString(),
    date,
  };
}
